import { Box, useTheme } from "@mui/material";
import { Pencil, Trash2 } from "lucide-react";
import type { FC } from "react";
import { SolutionItemActionRow } from "web_myplann/Goals/Components/SolutionItemActionRow";
import type { GoalFuturePortfolioResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

type Props = {
	open: boolean;
	futurePortfolio: GoalFuturePortfolioResponseDTO;
	onClose: () => void;
	onEdit: (futurePortfolio: GoalFuturePortfolioResponseDTO) => void;
	onRequestDelete: () => void;
};

export const FutureItemActionDrawer: FC<Props> = ({
	open,
	futurePortfolio,
	onClose,
	onEdit,
	onRequestDelete,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	const handleEdit = () => {
		onEdit(futurePortfolio);
		onClose();
	};

	const handleDelete = () => {
		onClose();
		onRequestDelete();
	};

	return (
		<MyPlannDrawer
			anchor="bottom"
			open={open}
			onClose={onClose}
			title={futurePortfolio.name}
			closeButton
		>
			<Box pb={1}>
				<SolutionItemActionRow
					onClick={handleEdit}
					Icon={Pencil}
					iconBg={theme.palette.success.light}
					iconColor={theme.palette.success.main}
					label={t(Resources.Goals.Detail.Solution.Pin.Future.edit)}
					hasDivider
				/>
				<SolutionItemActionRow
					onClick={handleDelete}
					Icon={Trash2}
					iconBg={theme.palette.error.light}
					iconColor={theme.palette.error.main}
					label={t(Resources.Goals.Detail.Solution.Pin.Future.delete)}
				/>
			</Box>
		</MyPlannDrawer>
	);
};
